import { Box, Typography, useTheme } from "@mui/material";
import { Property } from "../../../types";
import EditRentalInfo from "./edit-rental-info";
import { format } from "date-fns";
import InfoCell from "../../../../common/components/ui-kit/info-cell";
import useGetCurrentTenant from "@/modules/property-tracks/hooks/tenants/get-current-tenant.hook";

export default function PropertyRentalInfo({
  property,
}: Readonly<{
  property: Property;
}>) {
  const { data: currentTenantContract } = useGetCurrentTenant({
    propertyUid: property.uid,
  });
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        width: "100%",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={theme.nawy.typography.english.variants.body.md.semibold}
            >
              Rental Details
            </Typography>
            <EditRentalInfo property={property} />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "40px",
              justifyContent: "start",
            }}
          >
            <InfoCell
              title={`Showing Start Date`}
              description={
                property.propertyRental?.showingFrom
                  ? format(
                      new Date(property.propertyRental.showingFrom),
                      "d MMM yyyy"
                    )
                  : "N/A"
              }
            />
            <InfoCell
              title={`Rental Start Date`}
              description={
                property.propertyRental?.availableFrom
                  ? format(
                      new Date(property.propertyRental?.availableFrom),
                      "d MMM yyyy"
                    )
                  : "N/A"
              }
            />

            <InfoCell
              title={`Monthly Rental Price`}
              description={
                property.propertyRental?.rentalPrice?.toLocaleString() ?? "N/A"
              }
            />

            <InfoCell
              title={`Actual Rental Price`}
              description={
                currentTenantContract?.tenantContract?.rentStartValue
                  ? `EGP ${currentTenantContract.tenantContract.rentStartValue.toLocaleString()}`
                  : "N/A"
              }
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
